let store;

export function initStore (initStore) {
  store = initStore;
}

export function useStore () {
  return store;
}
